import { Component, ViewChild, AfterViewInit, ChangeDetectorRef, inject } from '@angular/core';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PositionsService } from '../../../services/position.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { FilterPosition } from '../../../models/filters/filter-position';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-positions',
  standalone: false,
  templateUrl: './positions.component.html',
  styleUrl: './positions.component.css'
})
export class PositionsComponent implements AfterViewInit {
  
  @ViewChild(TableComponent) positionsTable:TableComponent | undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;
  
  tableModel: tableModel= {
    columnModel:[{columnName:'Numero Posicion',columnValue:'positionNum'},
      {columnName:'Descripci\u00F3n',columnValue:'description'},
      {columnName:'Activo',columnValue:'active'}],
    dataSource:[],
    editButton:true,
    //viewDetail:true,
  };
  
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterPosition: FilterPosition = new FilterPosition;
  advancedSearch: boolean = false;

  private positionsService = inject(PositionsService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  constructor(private dialog: MatDialog) {}

  ngAfterViewInit() {
    //Promise.resolve().then(() =>  this.positionsTable.initTable());
  }

  ngOnInit(): void {
    this.searchPositionsPaginator();
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchPositionsPaginator();
  }
  editEvent(event: any){
    this.router.navigate(['/positions/edit', event.id]);
    /*const dialogRef = this.dialog.open(PositionsDetailComponent, {
      data: {
        width:700,
        position: event,
        readOnly: false
      }
    });*/
  }
  /*onShowAgregar(): void {
    const dialogRef = this.dialog.open(PositionsDetailComponent, {
      data: {
        width:700,
        position: undefined,
        readOnly: false
      }
    });
  }*/

  searchPositionsPaginator(){
    this.loading = true;

    this.positionsService.findAllPageablePositions(this.filterPosition, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.positionsTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }

}
